<template>
    <div class="content" :class="pointerIFg ? 'ButtonEvents' : ''" ref="contents">
        <!-- vant 时间选择器 -->
        <van-calendar ref="vanCalendar" v-model="show" :show-confirm="false" @confirm="onConfirm" color="#bb9975"
            :min-date="minDate" :max-date="maxDate" />
        <!-- 门店下拉框 -->
        <div class="title_xia">
            <!-- <div class="logos">
                <div class="logo">
                    <img src="../../assets/logo.png" alt="">
                </div>
            </div> -->
            <van-dropdown-menu>
                <van-dropdown-item v-model="value1" :options="option1" @change="SetDropdown" />
            </van-dropdown-menu>
        </div>
        <!-- 时间选择器 -->

        <!-- 固定的区域 -->
        <div style="height: 140px;" v-if="!classIfg"></div>
        <div class="fiexd" ref="fiexd" :class="classIfg ? 'flexdx' : 'fiexds'">
            <!-- logo -->
            <div class="title_nav" style="background-color:#ffffff;">
                <div class="nav">
                    <div>
                        <span class="nav_img">
                            <img src="../../assets/youbian.png"> </span><span class="nav_text "
                            @click="nextTa(0)">前一天</span>
                    </div>
                    <div class="onep">
                        <!-- <el-date-picker v-model="date" type="date" placeholder="选择日期" @change="SetDate(date)">
                    </el-date-picker> -->
                        <div @click="SetShow()">{{ date }}</div>
                    </div>
                    <div>
                        <span class="nav_text " @click="nextTa(1)">后一天</span> <span class="nav_img"><img
                                src="../../assets/Back.png"></span>
                    </div>
                </div>
            </div>
            <!-- 导航栏 -->
            <div class="tent_nav" v-if="!notIfg">
                <div style="display: flex;">
                    <div class="nav_contet" v-for="(itme, index) in reportNum" :key="itme">
                        <!-- {{ reportNum }} -->
                        <div>
                            <div class="nav_one" :class="SwiperIndex == itme - 1 ? 'res' : ''" @click="navto(itme)">
                            </div>
                        </div>
                        <div class="one_tow" v-if="itme !== reportNum"></div>
                    </div>
                </div>
                <div class="nav_text">
                    <div style="display: flex;" v-for="(itme) in reportNum">
                        <div :class="SwiperIndex == itme - 1 ? 'ddd' : ''" @click="navto(itme)">
                            <div v-if="itme == 2">上午</div>
                            <div v-if="itme == 3">下午</div>
                            <div v-if="itme == 1">全天</div>
                        </div>
                        <div style="width: 40px;" v-if="itme !== reportNum"></div>
                    </div>

                </div>
            </div>

        </div>
        <!-- 内容区 -->
        <div class="tent">
            <!-- 轮播图 -->
            <div class="lbimg">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div v-for="itme in reportData" class="lbimg_content swiper-slide" v-if="!notIfg">
                            <!-- 内容第一个区域 -->
                            <div class="content_one">
                                <div class="one_top" ref="oneTop" v-if="reportNum !== 0">
                                    <div class="top_imgs">
                                        <img src="../../assets/日历.png" alt="">
                                    </div>
                                    <div class="top_text">
                                        <div>开班时间：{{ begintime }}</div>
                                        <div style="margin-top: 12px;">结班时间：{{ createtime }}</div>
                                    </div>
                                </div>
                                <div class="ont_content">
                                    <!-- <div class="content_left">
                                        <div class="left_content">
                                            <div class="content_jin">备用金</div>
                                            <div class="content_qian">{{ settleworkinfor[0].imprestcashmoney }}元</div>
                                            <div ></div>
                                        </div>
                                    </div> -->
                                    <!-- <div class="right_content">
                                        <div class="right_top" style="display: flex;flex-direction: column;" v-for="(itme, index) in arr3l" :key="index">
                                            <div class="top_content" v-for="(itmes, index) in itme.content "
                                                :key="index">
                                                <div class="top_content_top"> <span class="text_top">{{ itmes.title
                                                        }}</span>
                                                    <div class="img" style="margin-left: 8px;"
                                                        @mouseover="mouseoverDoubt(itmes)" @mouseout="itmes.tole = 0"
                                                        v-if="itmes.messagg != undefined">
                                                        <img src="../../assets/问题-互动 (4) 2.png">
                                                    </div>
                                                </div>
                                                <span class="text_buttom">{{ itmes.price }}</span>
                                                <div class="doubt" v-if="itmes.tole == 1">
                                                    <div>
                                                        {{ itmes.messagg }}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div> -->

                                    <div class="right_content">
                                        <div class="right_top" v-for="(itme, index) in arr3" :key="index">
                                            <div class="top_content" v-for="(itmes, index) in itme.content "
                                                :key="index">
                                                <div class="top_content_top"> <span class="text_top">{{ itmes.title
                                                        }}</span>
                                                    <el-tooltip class="item" effect="dark" :value="itme.ifgs"
                                                        :content="itmes.messagg" placement="bottom">
                                                        <div class="img" style="margin-left: 8px;outline: 0 !important;"
                                                            @mouseover="mouseoverDoubt(itmes)"
                                                            @mouseout="itmes.tole = 0"
                                                            v-if="itmes.messagg != undefined">
                                                            <img style="outline: 0 !important;"
                                                                src="../../assets/问题-互动 (4) 2.png">
                                                        </div>
                                                    </el-tooltip>

                                                </div>
                                                <span class="text_buttom">{{ itmes.price }}</span>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 内容第二个区域 -->
                            <div class="content_tow">
                                <div class="tow_title">
                                    <div class="title_chu">
                                        <img src="../../assets/Rectangle 754.png">
                                    </div>
                                    <div class="title_top">
                                        <div>营收数据</div>
                                        <!-- <div class="top_red">今日累计：{{ jintiao.ActualAmount }}元</div> -->
                                    </div>

                                </div>
                                <div class="tow_content">
                                    <div class="tow_content_tent" v-for="(itme, index) in arr" :key="index">
                                        <div class="tow_content_tent_top">
                                            <div class="img">
                                                <img :src="itme.img">
                                            </div>
                                            <div style="color:#666666 ;" class="img_text">{{ itme.title }}</div>
                                            <el-tooltip class="item" effect="dark" :value="itme.ifgs"
                                                :content="itme.text" placement="bottom">
                                                <div class="img" style="margin-left: 8px;outline: 0 !important;"
                                                    @mouseover="mouseoverDoubt(itme)" @mouseout="itme.tole = 0"
                                                    v-if="itme.text">
                                                    <img style="outline: 0 !important;"
                                                        src="../../assets/问题-互动 (4) 2.png">
                                                </div>
                                            </el-tooltip>
                                            <!-- @click="touIfgs($event)" -->
                                            <div v-if="!itme.text"
                                                style="border: 1px solid #C2986E;border-radius: 25px;display: flex;
                                            justify-content: center;align-items: center;width: 32%;margin-left: 10px;height: 18px;display: none;">
                                                <div
                                                    style="display: flex;color: #C2986E;font-size: 12px;align-items: center;display: none;">
                                                    明细 <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
                                                </div>
                                            </div>

                                            <!-- <div class="doubt" v-if="itme.tole == 1">
                                                <div>
                                                    {{ itme.text }}
                                                </div>
                                            </div> -->

                                        </div>
                                        <div class="block">{{ itme.price }}元</div>
                                        <div class="fengjiexiao"></div>
                                        <div class="tow_content_tent_button">
                                            {{ itme.bfb }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 内容第三个区域 -->
                            <div class="content_throw">
                                <div class="tow_title">
                                    <div class="title_chu">
                                        <img src="../../assets/Rectangle 754.png">
                                    </div>
                                    <div class="title_top">
                                        <div>营业净额：{{ arr[0].price }}元</div>
                                    </div>

                                </div>
                                <div class="onsb">
                                    <div v-for="(itmes, index) in arr2" :key="index">
                                        <div class="throw_content">
                                            <div class="content_tow" v-for="(itme, index) in itmes.alles" :key="index"
                                              >
                                              <!-- @click="SetPageIfg1Loaging(itme, itme.title)" -->
                                                <div class="tow_top">
                                                    <div class="tow_img">
                                                        <div class="img">
                                                            <img :src="itme.img" alt="">
                                                        </div>
                                                        <div class="tow_img_text">{{ itme.title }}</div>
                                                    </div>
                                                    <div class="tow_right" v-if="itme.price1 !== 0">
                                                        {{ itme.price1 }}
                                                    </div>
                                                </div>
                                                <div class="tow_yuan">
                                                    <div>{{ itme.price ? itme.price : 0 }}元</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="fengjiexiao" v-if="itmes.fengjiexiao"></div>
                                    </div>
                                </div>
                            </div>
                            <!-- 内容第四个区域 -->
                            <div class="content_foue">
                                <div class="tow_title">
                                    <div class="title_chu">
                                        <img src="../../assets/Rectangle 754.png">
                                    </div>
                                    <div>优惠合计：{{ settleworkinfor[0].discontamount }}元</div>
                                </div>
                                <div class="foue_content">
                                    <div class="content">
                                        <div class="conten_one">
                                            <div>定额优惠</div>
                                            <div class="one_text">
                                                {{ settleworkinfor[0].reductionamount }}元
                                            </div>
                                        </div>
                                        <div class="content_title"></div>
                                        <div class="conten_one">
                                            <div>折扣优惠</div>
                                            <div class="one_text">{{ settleworkinfor[0].persondiscountamount }}元</div>
                                        </div>
                                        <div class="content_title"></div>
                                        <div class="conten_one">
                                            <div>赠送优惠</div>
                                            <div class="one_text">{{ settleworkinfor[0].giveamount }}元</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <not :width="widths" v-if="notIfg" />
                    </div>
                </div>
            </div>
        </div>
        <!-- 弹窗 -->
        <top v-if="PageIfg" style="z-index: 100000000;"></top>
        <tup v-if="tupIfg" style="z-index: 100000000;"></tup>
        <!-- 等待 -->
        <loading style="z-index: 10000000;" v-if="loadingIFg"></loading>
    </div>
</template>

<script>
import top from '../../components/top/index.vue'
import tup from '../../components/tup/index.vue'
import loading from '../../components/loading/index.vue'
import 'swiper/css/swiper.css'
import Swiper from 'swiper';
import not from '@/components/not/index.vue';
import { unZip } from '../../utils/ZIP/index.js';
import { Toast } from 'vant';
import moment from "moment";
export default {
    data() {
        return {
            notIfg: false,
            widths:100,
            value: 0,
            PagesIfg: false,
            option1: [

            ],
            // arr3l: [
            //     {
            //         content: [
            //             { title: "备用金", price: "134元", tole: 0 },
            //             { title: '人均消费', price: "68元", tole: 0, messagg: "人均消费=营业净额/就餐人数" },
            //         ]
            //     }
            // ],
            arr3: [
                // {
                //     content: [
                //         { title: "备用金", price: "134元", tole: 0 },
                //         {  title: '人均消费', price: "68元", tole: 0, messagg: "人均消费=营业净额/就餐人数" },
                //     ]
                // },

                {
                    content: [
                        { title: "备用金", price: "134元", tole: 0 },
                        { title: "开台数", price: "134台", tole: 0 },
                        { title: "就餐人数", price: "293人", tole: 0 },
                    ]
                },
                {
                    content: [
                        { title: '人均消费', price: "68元", tole: 0, messagg: "人均消费=营业净额/就餐人数", ifgs: false },
                        { title: '台均(散台)', price: "68元", tole: 0, messagg: "人均消费=营业净额/散台数", ifgs: false },
                        { title: '台均(包间)', price: "68元", tole: 0, messagg: "台均消费=营业净额/包间数", ifgs: false }
                    ]
                },

            ],
            arr: [
                { title: '营业净额', price: '2000', img: require('../../assets/应收金额.png'), price1: "987.71", tole: 0, bfb: null, text: ' 营业净额=所有结算方式的和', ifgs: false },
                { title: '退款金额', price: '1850', img: require('../../assets/退款金额.png'), price1: "987.71", tole: 0, bfb: null, },
                { title: '营业收入', price: '50', img: require('../../assets/优惠金额.png'), price1: "1", tole: 0, bfb: null, text: '营业收入=营业净额+退款', ifgs: false },
                { title: '营业额', price: '100', img: require('../../assets/实收金额.png'), price1: "10", tole: 0, bfb: null, text: '营业额=营业净额+优惠+代金券', ifgs: false },
            ],
            arr2: [
                {
                    alles: [
                        { title: '美团', img: require('../../assets/美团.png'), price: '840', price1: 12, tole: 0 },
                        { title: '抖音', img: require('../../assets/抖音.png'), price: '300', price1: 3, tole: 0 },
                    ],
                    fengjiexiao: true
                },
                {
                    alles: [
                        { title: '微信扫码', img: require('../../assets/微信.png'), price: '1551.51', price1: 0, tole: 1 },
                        { title: '微信线上', img: require('../../assets/微信.png'), price: '1213.51', price1: 0, tole: 1 },

                    ],
                    fengjiexiao: true
                },

                {
                    alles: [
                        { title: '支付宝', img: require('../../assets/支付宝支付.png'), price: '840', price1: 0, tole: 1 },
                        { title: '现金支付', img: require('../../assets/现金支付.png'), price: '63', price1: 0, tole: 1 },
                    ],
                    fengjiexiao: true
                },
                {
                    alles: [
                        { title: '挂帐', img: require('../../assets/挂账.png'), price: '300', price1: 0, tole: 1 },
                        { title: '招待', img: require('../../assets/招待.png'), price: '0', price1: 0, tole: 1 }
                    ],
                    fengjiexiao: false
                }

            ],
            date: "2023-12-22",
            lodDate: "2023-12-22",
            SwiperIndex: 0,
            indexYe: 0,
            swiper: null,
            title: "汤富贵城东店",
            oft: 0,
            stickyHeader: null,
            show: false,
            classIfg: true,
            minDate: new Date(2021, 0, 1),
            maxDate: new Date(2024, 11, 31),
            loadingIFg: true,
            pointerIFg: false,
            reportData: [],
            // 报表次数
            reportNum: 0,
            // 汉字数字
            ChineaNum: ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
            //真实数据
            realData: {},
            //开班
            createtime: null,
            //结班
            begintime: null,
            settleworkinfor: [],
            //实收金额
            paidmoney: 0,
            reductionmoney: 0,
            //优惠金额
            PeferentialMoney: 0,
            MtGetMel: {

            },
            DyGetMel: {},
            //美团总数量
            MtNum: {
                num: 0,
                price: 0,
            },
            dyNum: {
                num: 0,
                price: 0,
            },
            jintiao: {},
            customerEntity: 0,
            Stores: [],
            StoresId: "",
            value1: 0,
            jintiaos: {},
            reportDatas: [],
            agentid: '',
            code: '',
            userid: ''

        };
    },

    components: {
        top,
        loading,
        tup,
        not
    },
    methods: {
        SetShow() {
            this.show = true
        },
        touIfgs(e) {
            e.preventDefault();
            this.$store.commit('setTupIfg', true)
            document.body.style.overflow = 'hidden';

        },
        SetPageIfg(e, title,) {
            let datas = {
                title: title,
                flg: true,
                data: title === '美团' ? this.MtGetMel : this.DyGetMel,
            }
            e.price1 == 0 || this.$store.commit('SetPageIfg', datas)
            document.body.style.overflow = 'hidden';
        },
        SetPageIfg1Loaging(e, title,) {
            console.log(e);
            if (e.title === "美团" || e.title === "抖音") {
                this.openLoading(() => {
                    this.SetPageIfg(e, title,)
                }, 500)
            }

        },
        SetDate(e) {
            //判断是不是日期是不是前一天或者前两天
            this.lodDate = this.date
        },
        handleCommand(e) {
            this.title = e
        },
        navto(e) {
            this.swiper.slideTo(e - 1, 100, false)
        },
        handleScroll() {
            if (Math.trunc(document.documentElement.scrollTop) >= this.oft) {
                this.$refs.fiexd.style.position = 'fixed';
                this.$refs.fiexd.style.top = '0';
                this.classIfg = false
            }
            else if (Math.trunc(document.documentElement.scrollTop) < this.oft) {
                this.$refs.fiexd.style.position = 'static'
                this.$refs.fiexd.style.offsetTop = this.oft;
                this.classIfg = true
            }
        },
        formatDate(date) {
            this.loadingIFg = true
            this.pointerIFg = true
            let formattedDate = this.GetDate(date);
            setTimeout(() => {
                this.GetDate(date)
                this.GetPost(date, this.StoresId)
                this.SwiperIndex = 0
                this.navto(this.SwiperIndex + 1)
                this.loadingIFg = false
                this.pointerIFg = false
            }, 500);
            return formattedDate
        },
        GetDate(date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            return formattedDate;
        },
        //弹出loading组件 
        openLoading(func, Time) {
            this.loadingIFg = true
            this.pointerIFg = true
            setTimeout(() => {
                func()
                this.loadingIFg = false
                this.pointerIFg = false
            }, Time)
        },
        onConfirm(date) {
            this.show = false;
            this.date = this.formatDate(date);
        },
        nextTa(ifg) {
            this.loadingIFg = true
            this.pointerIFg = true
            setTimeout(async () => {
                if (ifg == 1) {
                    let dateTime = new Date(this.date);
                    dateTime = dateTime.setDate(dateTime.getDate() + 1);
                    let dateTimes = new Date(dateTime);
                    //判断日期是不是超过了最大日期和最新日期
                    if (dateTimes > this.maxDate || dateTimes < this.minDate) {
                        Toast.fail('日期选择错误');
                        this.loadingIFg = false
                        this.pointerIFg = false
                        return
                    }

                    const year = dateTimes.getFullYear();
                    const month = (dateTimes.getMonth() + 1).toString().padStart(2, '0');
                    const day = dateTimes.getDate().toString().padStart(2, '0');
                    const formattedDate = `${year}-${month}-${day}`;
                    this.date = formattedDate


                } else {
                    let dateTime = new Date(this.date);
                    dateTime = dateTime.setDate(dateTime.getDate() - 1);
                    let dateTimes = new Date(dateTime)
                    if (dateTimes > this.maxDate || dateTimes < this.minDate) {
                        Toast.fail('日期选择错误');
                        this.loadingIFg = false
                        this.pointerIFg = false
                        return
                    }
                    const year = dateTimes.getFullYear();
                    const month = (dateTimes.getMonth() + 1).toString().padStart(2, '0');
                    const day = dateTimes.getDate().toString().padStart(2, '0');
                    const formattedDate = `${year}-${month}-${day}`;
                    this.date = formattedDate
                }

                this.$nextTick(() => {
                    this.$refs.vanCalendar.reset(new Date(this.date))
                })
                await this.GetPost(this.data, this.StoresId)
                this.SwiperIndex = 0
                await this.navto(this.SwiperIndex + 1)
                this.loadingIFg = false
                this.pointerIFg = false
            }, 500)
        },
        async Setloading(a, time) {
            this.loadingIFg = true
            this.pointerIFg = true
            await setTimeout(() => {
                a()
                this.loadingIFg = false
                this.pointerIFg = false
            }, time)
        },
        GetDates(data) {
            const year = data.getFullYear();
            const month = (data.getMonth() + 1).toString().padStart(2, '0');
            const day = data.getDate().toString().padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            return formattedDate
        },
        mouseoverDoubt(itme) {
            itme.tole = 1
            setTimeout(() => {
                itme.tole = 0
            }, 5000)
        },
        //转换时间格式
        timestampToTime(timestamp) {
            var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
            var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
            var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
            console.log(Y);
            if(Y==='1900-'){
                return ''
            }
            return Y + M + D + h + m;
        },
        //转换时间戳
        timestamps(date) {
            let dates = new Date(date)
            var timestamp = Date.parse(dates);
            return this.timestampToTime(timestamp)
        },
        andleTouchStart(data) {
            //    this.arr.forEach(e=>{
            //     // console.log(e);
            //     e.ifgs=false
            //    })
            //    this.arr3[1].content.forEach(e=>{
            //     console.log(e);
            //     // e.ifgs=false
            //    })
            let ls = document.querySelectorAll('.el-tooltip__popper')
            console.log(ls);
            ls.forEach(e => {
                e.style.display = 'none'
            })
        },
        isDa(){
            let date=''
            const now = moment();

            // 创建指定时间，例如15:00
            const specificTime = moment('09:00', 'HH:mm');

            // 判断当前时间是否小于或等于指定时间
            if (now.isBefore(specificTime) || now.isSame(specificTime)) {
                date = moment(new Date()).subtract(1,'days').format("YYYY/MM/DD")
                console.log('当前时间小于或等于指定时间');
            } else {
                date = moment(new Date()).format("YYYY/MM/DD")
                console.log('当前时间大于指定时间');
            }
            return date
        },
        async mounteds() {
            //获取前一天的数据
            // let data = new Date();
            // let dateTime = new Date(data);
            // dateTime = dateTime.setDate(dateTime.getDate() - 1);
            // let dateTimes = new Date(dateTime)
            // const year = dateTimes.getFullYear();
            // const month = (dateTimes.getMonth() + 1).toString().padStart(2, '0');
            // const day = dateTimes.getDate().toString().padStart(2, '0');
            // const formattedDate = `${year}-${month}-${day}`;
            // const formattedDate = 2023 + '-' + 10 + '-' + 23;
            this.date = this.isDa()

            setTimeout(() => {
                this.stickyHeadre =
                    // console.log(this.stickyHeadre.offsetTop);
                    this.oft = this.$refs.fiexd.offsetTop;
            }, 200)
            // console.log(this.$refs);
            window.addEventListener('scroll', this.handleScroll)
            document.addEventListener('touchstart', this.andleTouchStart, false);
            let vm = this
            this.swiper = new Swiper(".swiper-container", {
                loop: true,
                mousewheel: true,
                keyboard: true,
                observer: true,
                observeParents: true,
                on: {
                    slideChange: function () {
                        // -> 这里的this指的是Swiper的this对象,不是vue的,所以要将VUe的this对象声明vm指向vue实例,这里就是轮播图的切换下标
                        vm.SwiperIndex = this.realIndex
                        console.log(1);
                        vm.GetRealData(this.realIndex)
                        //改变时间
                        // let dateTime = new Date(vm.lodDate);
                        // dateTime = dateTime.setDate(dateTime.getDate() + vm.SwiperIndex);
                        // let dateTimes = new Date(dateTime)
                        // const year = dateTimes.getFullYear();
                        // const month = (dateTimes.getMonth() + 1).toString().padStart(2, '0');
                        // const day = dateTimes.getDate().toString().padStart(2, '0');
                        // const formattedDate = `${year}-${month}-${day}`;
                        // console.log(formattedDate);
                        // vm.date = formattedDate
                    }
                },
                navigation: {
                    // nextEl: ".next_text",
                    // prevEl: ".pre_text"
                }
            });
            await this.GetStoreId()
            await this.GetPost(this.date, this.Stores[0].id)
            // await this.GetPosts(this.Stores[0].id)
            //不能看明天的
            let date = new Date();
            this.maxDate = this.AddDay(date)
            this.$nextTick(() => {
                this.$refs.vanCalendar.reset(new Date(this.date))
            })


        },
        //加一天
        AddDay(date) {
            let dateTime = new Date(date);
            dateTime = dateTime.setDate(dateTime.getDate());
            let dateTimes = new Date(dateTime)
            return dateTimes;
        },
        // async GetPost(date, id) {

        //     let PostData = {
        //         storeid: id, //门店id
        //         beginDate: this.date, //开始时间
        //         endDate: `${this.date} 23:59:59` //截止时间
        //     }
        //     let { ReturnTag } = await this.$server.post(`/WeCom/GetSettleWorkReportData`, PostData)
        //     let cunZips = unZip(ReturnTag)
        //     this.reportData = JSON.parse(cunZips)
        //     //判断第一班的时间是不是大于第二班的时间
        //     this.IfTime(this.reportData)
        //     //今天总金额
        //     let ActualAmount = 0
        //     //今天优惠金额
        //     let PreferentialAmount = 0
        //     //今天退款金额
        //     let refund = 0
        //     //今天实收金额
        //     let paidmoneys = 0
        //     //今天营收金额
        //     let arrOne = parseFloat(0)
        //     //今天退款金额
        //     let arrTow = parseFloat(0)
        //     //今天营业收入
        //     let arrThree = parseFloat(0)
        //     //今天营业额
        //     let arrFrom = parseFloat(0)
        //     this.reportData.forEach(e => {
        //         console.log(e);
        //         ActualAmount += e.settleworkinfor[0].paymoney + e.settleworkinfor[0].wxscanrefundmoney + e.settleworkinfor[0].xcxrefundmoney + e.settleworkinfor[0].alirefundmoney + e.settleworkinfor[0].cashrefundmoney + parseFloat(e.settleworkinfor[0].reductionmoney) + parseFloat(e.settleworkinfor[0].persondiscountmoney) + parseFloat(e.settleworkinfor[0].givemoney)
        //         PreferentialAmount += parseFloat(e.settleworkinfor[0].reductionmoney) + parseFloat(e.settleworkinfor[0].persondiscountmoney) + parseFloat(e.settleworkinfor[0].givemoney)
        //         refund += e.settleworkinfor[0].wxscanrefundmoney + e.settleworkinfor[0].xcxrefundmoney + e.settleworkinfor[0].alirefundmoney + e.settleworkinfor[0].cashrefundmoney
        //         paidmoneys = (ActualAmount - PreferentialAmount - refund)
        //         let ssjn = (parseFloat((e.settleworkinfor[0].paidmoney).toFixed(2)))
        //         let ysjn = (parseFloat(e.settleworkinfor[0].wxscanrefundmoney) + parseFloat(e.settleworkinfor[0].xcxrefundmoney) + parseFloat(e.settleworkinfor[0].alirefundmoney) + parseFloat(e.settleworkinfor[0].cashrefundmoney)).toFixed(2)
        //         let money = (parseFloat(ssjn) - parseFloat(ysjn)).toFixed(2)
        //         // console.log(parseFloat(money));
        //         arrOne = parseFloat(arrOne) + parseFloat(money)
        //         arrTow += parseFloat(ysjn)

        //         arrThree = (parseFloat(arrThree) + parseFloat(ssjn) + parseFloat(ysjn))
        //         console.log(arrThree);
        //         let sumPrice = parseFloat(0)
        //         e.mtvoucher.forEach(e => {
        //             console.log(e);
        //             sumPrice += parseFloat(e.subsidymoney) * parseFloat(e.qty)
        //         })
        //         e.dyvoucher.forEach(e => {
        //             sumPrice += parseFloat(e.subsidymoney) * parseFloat(e.qty)
        //         })
        //         let PeferentialMoney = (parseFloat(e.settleworkinfor[0].reductionmoney) + parseFloat(e.settleworkinfor[0].persondiscountmoney) + parseFloat(e.settleworkinfor[0].givemoney)).toFixed(2)
        //         arrFrom += parseFloat(arrOne) + parseFloat(PeferentialMoney) + parseFloat(sumPrice)
        //     })


        //     let arrs = {
        //         customerEntity: {
        //             customerSum: 0
        //         },
        //         dysetmeal: [],
        //         dyvoucher: [],
        //         mtsetmeal: [],
        //         mtvoucher: [],
        //         settleworkinfor: [{
        //             code: "", //结班单号
        //             createtime: "", //结班时间
        //             ordernum: 0, //订单数量
        //             tablenum: 0, //翻台数
        //             paymoney: 0.00, //应收总金额
        //             paidmoney: 0.00, //已付款金额
        //             xcxmoney: 0.00, //小程序金额
        //             alipaymoney: 0.00, //支付宝扫码金额
        //             wxscanmoney: 0.0, //微信扫码金额
        //             vouchermoney: 0.00, //代金券金额
        //             semealmoney: 0.00, //套餐金额
        //             givemoney: 0.00, //赠送金额
        //             cashmoney: 0.00, //现金金额
        //             freemoney: 0.00, //门店招待金额
        //             creditmoney: 0.00, //挂账金额
        //             persondiscountmoney: 0.00, //折扣金额-
        //             reductionmoney: 0.00, //定额优惠金额
        //             othermoney: 0.00, //其他金额
        //             wxscanrefundmoney: 0.00, //微信扫码退款金额
        //             xcxrefundmoney: 0.00, //小程序退款金额
        //             alirefundmoney: 0.00, //支付宝退款金额
        //             cashrefundmoney: 0.00, //现金退款金额
        //             nomoney: 0.00, //未付款订单金额
        //             imprestcashmoney: 0, //备用金
        //             begintime: "", //开班时间
        //             storename: "" //门店
        //         }]
        //     }
        //     console.log(this.reportData[0]);

        //     this.reportData.forEach(e => {
        //         arrs.customerEntity.customerSum += e.customerEntity.customerSum
        //         arrs.dysetmeal = arrs.dysetmeal.concat(e.dysetmeal)
        //         arrs.dyvoucher = arrs.dyvoucher.concat(e.dyvoucher)
        //         arrs.mtsetmeal = arrs.mtsetmeal.concat(e.mtsetmeal)
        //         arrs.mtvoucher = arrs.mtvoucher.concat(e.mtvoucher)
        //         arrs.settleworkinfor[0].createtime = e.settleworkinfor[0].createtime
        //         arrs.settleworkinfor[0].ordernum += e.settleworkinfor[0].ordernum
        //         arrs.settleworkinfor[0].tablenum += e.settleworkinfor[0].tablenum
        //         arrs.settleworkinfor[0].paymoney += parseFloat(e.settleworkinfor[0].paymoney)
        //         arrs.settleworkinfor[0].paidmoney += parseFloat(e.settleworkinfor[0].paidmoney)
        //         arrs.settleworkinfor[0].xcxmoney += parseFloat(e.settleworkinfor[0].xcxmoney)
        //         arrs.settleworkinfor[0].alipaymoney += parseFloat(e.settleworkinfor[0].alipaymoney)
        //         arrs.settleworkinfor[0].wxscanmoney += parseFloat(e.settleworkinfor[0].wxscanmoney)
        //         arrs.settleworkinfor[0].vouchermoney += parseFloat(e.settleworkinfor[0].vouchermoney)
        //         arrs.settleworkinfor[0].semealmoney += parseFloat(e.settleworkinfor[0].semealmoney)
        //         arrs.settleworkinfor[0].givemoney += parseFloat(e.settleworkinfor[0].givemoney)
        //         arrs.settleworkinfor[0].cashmoney += parseFloat(e.settleworkinfor[0].cashmoney)
        //         arrs.settleworkinfor[0].freemoney += parseFloat(e.settleworkinfor[0].freemoney)
        //         e.settleworkinfor[0].creditmoney = e.settleworkinfor[0].creditmoney == null ? 0 : e.settleworkinfor[0].creditmoney
        //         arrs.settleworkinfor[0].creditmoney += parseFloat(e.settleworkinfor[0].creditmoney)
        //         arrs.settleworkinfor[0].persondiscountmoney += parseFloat(e.settleworkinfor[0].persondiscountmoney)
        //         e.settleworkinfor[0].reductionmoney = (parseFloat(e.settleworkinfor[0].reductionmoney)).toFixed(2)
        //         arrs.settleworkinfor[0].reductionmoney += parseFloat(e.settleworkinfor[0].reductionmoney)
        //         arrs.settleworkinfor[0].othermoney += parseFloat(e.settleworkinfor[0].othermoney)
        //         arrs.settleworkinfor[0].wxscanrefundmoney += parseFloat(e.settleworkinfor[0].wxscanrefundmoney)
        //         arrs.settleworkinfor[0].xcxrefundmoney += parseFloat(e.settleworkinfor[0].xcxrefundmoney)
        //         arrs.settleworkinfor[0].alirefundmoney += parseFloat(e.settleworkinfor[0].alirefundmoney)
        //         arrs.settleworkinfor[0].cashrefundmoney += parseFloat(e.settleworkinfor[0].cashrefundmoney)
        //         arrs.settleworkinfor[0].nomoney += parseFloat(e.settleworkinfor[0].nomoney)
        //         arrs.settleworkinfor[0].imprestcashmoney += parseFloat(e.settleworkinfor[0].imprestcashmoney)
        //         arrs.settleworkinfor[0].begintime = this.reportData[0].settleworkinfor[0].begintime
        //         arrs.settleworkinfor[0].storename = this.reportData[0].settleworkinfor[0].storename
        //     })
        //     this.reportData.push(arrs)
        //     arrs.settleworkinfor[0].reductionmoney = (parseFloat(arrs.settleworkinfor[0].reductionmoney)).toFixed(2)
        //     console.log(this.reportData);
        //     this.jintiao = {
        //         ActualAmount,
        //         PreferentialAmount,
        //         refund,
        //         paidmoneys
        //     }
        //     this.jintiaos = {
        //         arrOne,
        //         arrTow,
        //         arrThree,
        //         arrFrom
        //     }
        //     console.log(this.jintiaos);
        //     this.jintiao.ActualAmount = (this.jintiao.ActualAmount).toFixed(2)
        //     // this.reportNum = this.reportData.length
        //     this.GetRealData(0)
        // },
        async GetPost(date, id) {
           
            this.reportData=[]
            let PostData = {
                storeid: id, //门店id
                beginDate: this.date, //开始时间
                // endDate: `${this.date} 23:59:59` //截止时间
            }
            let { ReturnTag } = await this.$server.post(`/WeCom/GetSettleWorkNewReportData`, PostData)
            let cunZips = unZip(ReturnTag)
            // this.notIfg=true
            // if (JSON.parse(cunZips).resultAllList[0].settleamount !== 0) {
                // this.notIfg = false
                this.reportData = JSON.parse(cunZips)
                this.reportNum = 3
                this.GetRealData(0)
            // }
            // console.log(this.notIfg);
        },
        GetRealData(index) {
            // this.realData = this.reportData[index]
            console.log(index);
            console.log(this.reportData);
            if (index == 1) {
                this.realData = this.reportData.resultFirstList
            } else if (index == 2) {
                this.realData = this.reportData.resultSecondList
            } else if (index == 0) {
                this.realData = this.reportData.resultAllList
            }
            console.log(this.realData);
            if (this.realData === undefined) return
            //今日实收金额
            this.settleworkinfor = this.realData
            //就餐人数
            // this.customerEntity = this.realData.customerEntity.customerSum == null ? 0 : this.realData.customerEntity.customerSum
            this.arr3[0].content[2].price = `${this.settleworkinfor[0].havemealqty}人`
            this.arr3[0].content[0].price = `${this.settleworkinfor[0].begincashmoney}元`
            //开班时间-结班时间
            this.begintime = this.timestamps(this.settleworkinfor[0].beginworktime)
            this.createtime = this.timestamps(this.settleworkinfor[0].settleworktime)
            //开台数 客单量  客单价
            // this.settleworkinfor[0].tableavgamount=(this.settleworkinfor[0].tableavgamount).toFixed(2)
            // this.settleworkinfor[0].roomavgamount=(this.settleworkinfor[0].roomavgamount).toFixed(2)
            // this.settleworkinfor[0].personavgamount=(this.settleworkinfor[0].personavgamount).toFixed(2)
            this.arr3[0].content[1].price = `${this.settleworkinfor[0].dintableqty}台`
            this.arr3[1].content[1].price = `${this.settleworkinfor[0].tableavgamount}元`
            this.arr3[1].content[2].price = `${this.settleworkinfor[0].roomavgamount}元`
            //客单价=总金额/客单量
            // let price = (this.settleworkinfor[0].paymoney / this.settleworkinfor[0].ordernum)
            // price = this.settleworkinfor[0].paymoney == 0 ? 0 : price
            // this.arr3[0].content[1].price = `${Math.floor(price)}元`
            //实收金额取整
            this.paidmoney = (this.settleworkinfor[0].settleamountincludenopay).toFixed(2)
            //微信扫码和微信线上和支付宝和现金支付和挂帐和招待
            this.arr2[1].alles[0].price = (this.settleworkinfor[0].scanwxamount).toFixed(2)
            this.arr2[1].alles[1].price = (this.settleworkinfor[0].onlinewxamount).toFixed(2)
            this.arr2[2].alles[0].price = (this.settleworkinfor[0].alipayamount).toFixed(2)
            // this.settleworkinfor[0].creditmoney = this.settleworkinfor[0].creditmoney == null ? 0 : this.settleworkinfor[0].creditmoney
            this.arr2[2].alles[1].price = (this.settleworkinfor[0].cashamount).toFixed(2)
            this.arr2[3].alles[0].price = (this.settleworkinfor[0].creditamount).toFixed(2)
            this.arr2[3].alles[1].price = (this.settleworkinfor[0].freeamount).toFixed(2)
            //计算优惠金额
            this.PeferentialMoney = this.settleworkinfor[0].discontamount
            // 合并美团待金券和团购套餐 以及  合并抖音待金券和团购套餐
            // this.MtGetMel = {
            //     mtsetmeal: this.realData.mtsetmeal,
            //     mtvoucher: this.realData.mtvoucher,
            // },
            // this.DyGetMel = {
            //         mtsetmeal: this.realData.dysetmeal,
            //         mtvoucher: this.realData.dyvoucher,
            // }
            //计算美团待金券和团购套餐数量和总金以及  计算抖音待金券和团购套餐美团总金
            // this.settleworkinfor[0].persondiscountmoney = (parseFloat(this.settleworkinfor[0].persondiscountmoney)).toFixed(2)
            // this.settleworkinfor[0].givemoney = this.parseFloats(this.settleworkinfor[0].givemoney)
            // this.MtNum = this.SetNum(this.MtGetMel)
            // this.DyNum = this.SetNum(this.DyGetMel)
            this.arr2[0].alles[0].price = (this.settleworkinfor[0].Mamount).toFixed(2)
            this.arr2[0].alles[1].price = (this.settleworkinfor[0].Damount).toFixed(2)
            this.arr2[0].alles[0].price1 = this.settleworkinfor[0].Mqty
            this.arr2[0].alles[1].price1 = this.settleworkinfor[0].Dqty
            //修改应收金额 实收金额 优惠金额 退款金额
            // let ssjn = (parseFloat((this.settleworkinfor[0].paidmoney).toFixed(2)))
            // let ysjn = (this.settleworkinfor[0].wxscanrefundmoney + this.settleworkinfor[0].xcxrefundmoney + this.settleworkinfor[0].alirefundmoney + this.settleworkinfor[0].cashrefundmoney).toFixed(2)
            // this.arr[3].price = (this.settleworkinfor[0].wxscanrefundmoney + this.settleworkinfor[0].xcxrefundmoney + this.settleworkinfor[0].alirefundmoney + this.settleworkinfor[0].cashrefundmoney).toFixed(2)

            // this.arr[0].price = (parseFloat(this.arr[1].price) + parseFloat(this.arr[3].price) + parseFloat(this.PeferentialMoney)).toFixed(2)
            // console.log(ysjn);
            this.arr[0].price = (this.settleworkinfor[0].settleamount).toFixed(2)
            this.arr[1].price = (this.settleworkinfor[0].refundamount).toFixed(2)
            this.arr[2].price = (this.settleworkinfor[0].operatingincome).toFixed(2)
            this.arr[3].price = (this.settleworkinfor[0].turnover).toFixed(2)
            // let message = parseInt(parseFloat(this.arr[0].price) / parseFloat(this.customerEntity))
            // let messages = parseInt(parseFloat(this.arr[0].price) / parseFloat(this.settleworkinfor[0].ordernum))
            this.arr3[1].content[0].price = `${this.settleworkinfor[0].personavgamount}元`
            // this.arr3[1].content[2].price = `${messages}元`
            //计算百分比    
            // this.arr[0].bfb = this.convertToPercentage(parseInt(this.arr[0].price / this.jintiaos.arrOne))
            // this.arr[2].bfb = this.convertToPercentage(parseInt(this.arr[2].price / this.jintiaos.arrThree))
            // this.arr[3].bfb = this.convertToPercentage(parseInt(this.arr[3].price / this.jintiaos.arrFrom))
            // this.arr[1].bfb = this.convertToPercentage(parseInt(this.arr[1].price / this.jintiaos.arrTow))
            this.arr[0].bfb = `今日占比: ${this.settleworkinfor[0].settleamountratio}`
            this.arr[2].bfb = `今日占比: ${this.settleworkinfor[0].operatingincomeratio}`
            console.log(this.settleworkinfor[0].operatingincomeratio);
            this.arr[3].bfb = `今日占比: ${this.settleworkinfor[0].turnoverratio}`
            this.arr[1].bfb = `今日占比: ${this.settleworkinfor[0].refundamountratio}`
            // this.settleworkinfor[0].discontamount=(this.settleworkinfor[0].discontamount).toFixed(2)
            // this.settleworkinfor[0].reductionamount=(this.settleworkinfor[0].reductionamount).toFixed(2)
            // this.settleworkinfor[0].giveamount=(this.settleworkinfor[0].giveamount).toFixed(2)
            // this.settleworkinfor[0].persondiscountamount=( this.settleworkinfor[0].persondiscountamount).toFixed(2)
        },
        SetNum(data) {
            let qtys = 0
            let money = 0
            data.mtvoucher.forEach(element => {
                qtys = qtys + Number(element.qty)
                money = money + Number(element.amount)
            });
            data.mtsetmeal.forEach(element => {
                qtys = qtys + Number(element.qty)
                money = money + Number(element.payamount)
            });

            return { qtys, money }
        },
        convertToPercentage(num) {
            if (isNaN(num)) return '100%';
            return (num * 100) + "%";
        },
        //返回整数
        parseFloats(num) {
            return (parseFloat(num)).toFixed(2)
        },
        //获取门店的id
        async GetStoreId() {
            let { ReturnTag } = await this.$server.post(`/WeCom/GetStoresByQWChatUserid`, {
                userid:this.userid
            })
            let cunZips = unZip(ReturnTag)
            this.Stores = JSON.parse(cunZips)
            console.log(this.Stores);
            //门店title 赋值给option1
            let index = 0
            this.Stores.forEach(e => {
                this.option1.push({
                    text: e.name,
                    value: index
                })
                index++
            })
            for (let index = 0; index < this.Stores.length; index++) {
                this.option1[index].text = this.Stores[index].name
            }
            this.StoresId = this.Stores[0].id

        },
        //改变门店
        SetDropdown() {
            this.GetPost(this.date, this.Stores[this.value1].id)
            this.StoresId = this.Stores[this.value1].id
        },
        //判断第一班的时间是不是大于第二班的时间 进行排序
        IfTime(data) {
            for (let i = 0; i < data.length; i++) {
                for (let j = 0; j < data.length - 1 - i; j++) {
                    let date = new Date(data[j].settleworkinfor[0].begintime)
                    let date1 = new Date(data[j + 1].settleworkinfor[0].begintime)
                    if (date > date1) {
                        let temp = data[j]
                        data[j] = data[j + 1]
                        data[j + 1] = temp
                    }
                }
            }
        },
        SetPagesIfg() {
            this.PagesIfg = true
        },
        async getopenid(code, agentid) {
            let datas = {
                code: code,
                agentid: agentid,
                // agentid: 1000032
            }
            let { ReturnTag } = await this.$server.post('/WeCom/GetUserid', datas)
            let data = unZip(ReturnTag);
            data = JSON.parse(data)
            if (data !== null) {
                var loginurl = data; //登录路径
                this.userid = loginurl; //获取了usid
                // alert(this.userid)
                console.log(this.userid);
                this.$cookies.set('userid', this.userid)
                sessionStorage.setItem('userid', this.userid)
                await this.mounteds()
                await this.SetPagesIfg()
            } else {
                await this.$message.closeAll()
                await this.$message.error("你没有进入权限")
                throw new Error('你没有进入权限')
            }
        },
    },
    computed: {
        PageIfg() {
            return this.$store.state.PageIfg
        },
        tupIfg() {
            return this.$store.state.tupIfg
        }
    },
    async mounted() {
        // this.notIfg = true
        this.loadingIFg = true
        this.pointerIFg = true
        this.agentid = this.$route.query.agentid
        this.code = this.$route.query.code
        this.userid = this.$cookies.get('userid')
        this.userid = sessionStorage.getItem('userid')
        console.log(this.userid);
        let selectedstore = this.$cookies.get('selectedstore')
        if (selectedstore != null && selectedstore != '' && selectedstore != undefined) {
            this.selectedstore = selectedstore
        }
        // 
        if ((this.code != null && this.code != "" && this.code != undefined) && (this.userid == null || this.userid == '' || this.userid == undefined)) {
            // console.log(123456);
            await this.getopenid(this.code, this.agentid);
        } else if (this.userid != null && this.userid != '' && this.userid != undefined) {
            // await this.GetPush()
            await this.mounteds()
            await this.SetPagesIfg()
        }
        // await this.mounteds()
        // await this.SetPagesIfg()
        await setTimeout(() => {
            this.loadingIFg = false
            this.pointerIFg = false
        }, 1000)
        document.title = this.$route.meta.title
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/hotcss/hotcss-master/src/px2rem.scss';

body {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent
}

::v-deep .van-dropdown-item__option--active {
    color: #000;
}

.oua:before {
    content: '\e660';
}

// .van-icon-arrow:before {
//     content: '\e660';
// }
::v-deep .van-dropdown-menu__title--active::after {
    color: #000;
}

::v-deep .van-dropdown-item__option--activ {
    color: #000;
}

::v-deep .van-calendar__weekdays {
    background-color: #f4efe9;
}

::v-deep .van-calendar__header-subtitle {
    background-color: #f4efe9;
}

//修改elementUI样式中日期选择器 
::v-deep .el-input__inner {
    height: 14px;
    width: 100%;
    text-align: center;
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;
    /* font-size: 1px; */
    /* font-weight: 600; */
    line-height: normal !important;
    display: flex !important;
    align-items: center !important;
    color: #333;
    text-align: center;
    font-family: Alibaba PuHuiTi;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
}

::v-deep .van-dropdown-menu {
    width: 100%;
}

::v-deep .van-dropdown-menu__bar {
    box-shadow: none;
}

// ::v-deep .el-tooltip {
//     box-sizing: none;
// }

::v-deep .van-ellipsis {
    color: #333;
    text-align: center;
    font-family: Alibaba PuHuiTi 3.0;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
}

.el-dropdown-menu {
    width: 134px;
}

//使点击事件失效
.ButtonEvents {
    pointer-events: none;
}

.content {
    position: relative;
    max-width: 520px;
    min-width: px2rem(320);
    margin: auto;
    // width: 100%;
    height: 100%;


    .logo {
        width: 100%;
        background-color: #ffffff;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 163px;
            height: 64px;
        }
    }

    //导航栏
    .tent_nav {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 80px;
        padding: 8px;
        padding-bottom: 0px;
        background-color: #f5f5f5;

        .nav_contet {
            display: flex;
            align-items: center;

            .nav_one {
                width: 12px;
                height: 12px;
                border-radius: 50%;
                border: 1px solid #cccc;
                background-color: #DDD;
            }

            .one_tow {
                width: 36px;
                height: 1px;
                background: #DDD;
                margin-left: 8px;
                margin-right: 8px;
            }

            .res {
                background-color: #CA0000;
            }
        }

        .nav_text {
            display: flex;
            // width: 180px;
            justify-content: space-between;
            margin-top: 8px;


            div {

                color: #DDD;
                font-family: Source Han Sans CN;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
            }

            .ddd {
                color: #333;
            }
        }
    }

    .fiexds {
        width: calc(100% - 16px) !important;
    }

    .flexdx {
        width: calc(100% - 16px) !important;
    }

    .fiexd {
        // position: fixed;
        position: static;
        max-width: calc(520px - 16px);
        min-width: px2rem(320);
        z-index: 30;
        background-color: #f5f5f5;
        // padding: 8px;
        padding-bottom: 0;

        .one_top {
            // position: fixed;
            // top: 50%;
            // // left: 0;
            border-radius: 10px;
            background-color: #ffffff;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            padding: 12px;
            position: sticky;
            // width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: nowrap;

            .top_imgs {
                width: 44px;
                height: 44px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: nowrap;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .top_text {
                margin-left: 8px;
                color: #C2986E;
                font-family: Alibaba PuHuiTi;
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
            }
        }

    }

}

.onsb {
    padding-left: px2rem(20);
    padding-top: px2rem(20);
    padding-right: px2rem(20);
    display: flex;
    flex-direction: column;

    .fengjiexiao {
        width: 100%;
        border: px2rem(1) dashed #f5f5f5;
        margin-top: px2rem(0) !important;
        margin-bottom: px2rem(0) !important;
    }
}

// 标题样式
.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 44px;
    position: relative;

    .title_img {
        width: 24px;
        height: 24px;
        margin-left: 16px;

        img {
            width: 100%;
            height: 100%;
            flex-shrink: 0;
        }
    }

    .title_content {
        width: 100%;
        text-align: center;
        position: absolute;
        font-family: Source Han Sans CN;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        color: #333;
    }
}

// 门店下拉框样式
.title_xia {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
        color: #333;
        font-family: Alibaba PuHuiTi 3.0;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
    }

}

.fengjiexiao {
    width: 100%;
    border: px2rem(1) dashed #f5f5f5;
    margin-top: px2rem(20);
    margin-bottom: px2rem(20);
}

.yes {
    color: #00bf2a;
}

.reds {
    color: #e30f0f;
}

// 时间选择器
.title_nav {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 50px;
    align-items: center;
    padding: 8px;
    padding-bottom: 0px;

    .nav {
        width: 95%;
        display: flex;
        justify-content: space-between;

        .nav_img {
            margin-right: px2rem(5);
        }

        img {
            width: 12px;
            height: 12px;
        }

        .nav_text {
            color: #666;
            font-family: Alibaba PuHuiTi;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
        }

        .onep {
            ::v-deep i {
                display: none;
            }

            span {
                color: #333;
                font-family: Alibaba PuHuiTi;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
            }
        }
    }
}

.el-tooltip,
.el-tooltip:focus,
.el-tooltip:focus-visible {
    outline: transparent auto 0px !important;
}

.el-divider--horizontal {
    margin: px2rem(20) 0;
}

.van-cell__left-icon,
.van-cell__right-icon {
    font-size: 12px;
    color: #C2986E;
}

// 内容
.tent {
    height: 100%;
    background-color: #f5f5f5;
    padding: 8px;
    padding-top: 0;

    .lbimg {
        display: flex;
        overflow: hidden;

        .lbimg_content {
            width: 100%;
            flex-shrink: 0;
        }


    }

    //logo


    .content_one {
        border-radius: 10px;
        background-color: #ffffff;
        padding: 12px;
        padding-top: 0;
        display: flex;
        flex-direction: column;
        border-top-right-radius: 0;
        border-top-left-radius: 0;

        .one_top {
            // position: fixed;
            // top: 50%;
            // // left: 0;
            border-radius: 10px;
            background-color: #ffffff;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            padding: 12px;
            position: sticky;
            // width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: nowrap;

            .top_imgs {
                width: 44px;
                height: 44px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: nowrap;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .top_text {
                margin-left: 8px;
                color: #C2986E;
                font-family: Alibaba PuHuiTi;
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
            }
        }

        .ont_content {
            // margin-top: 55px;
            width: 100%;
            height: 128px;
            border-radius: 5px;
            background: #F8F8F8;
            display: flex;
            align-items: center;

            .content_left {
                width: 34%;
                height: 128px;

                .left_content {
                    display: flex;
                    height: 128px;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;

                    img {
                        width: 24px;
                        height: 24px;
                    }

                    div {
                        margin-top: 8px;
                    }

                    .content_jin {
                        color: #666;
                        font-family: Alibaba PuHuiTi;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                    }

                    .content_qian {
                        color: #333;
                        font-family: Alibaba PuHuiTi 3.0;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 500;
                    }
                }
            }

            .fengjiexian {
                width: 1px;
                height: 104px;
                background: rgba(221, 221, 221, 0.87);
            }

            .right_content {
                display: flex;
                flex: 1;
                flex-direction: column;

                .right_top {
                    display: flex;
                    justify-content: space-between;
                    margin-left: 12px;
                    margin-right: 12px;
                    margin-top: 8px;
                    margin-bottom: 8px;

                    .top_content {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        width: 45%;
                        height: 40px;

                        .doubt {
                            padding: 8px;
                            border-radius: 2px;
                            background: rgba(0, 0, 0, 0.70);
                            position: absolute;
                            margin-top: 20px;
                            // margin-right: 20px;
                            display: flex;

                            div {
                                color: #FFF;
                                font-family: Alibaba PuHuiTi 3.0;
                                font-size: 12px;
                                font-style: normal;
                                font-weight: 400;
                                display: inline-block;
                                flex-wrap: nowrap;
                                white-space: nowrap;
                            }
                        }

                        .top_content_top {
                            display: flex;

                            .img {
                                width: 16px;
                                height: 16px;

                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                        }

                        .text_top {
                            color: #666;
                            text-align: center;
                            font-family: Alibaba PuHuiTi;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 400;
                        }

                        .text_buttom {
                            color: #333;
                            text-align: center;
                            font-family: Alibaba PuHuiTi;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 500;
                            line-height: 18px;
                            margin-top: px2rem(8);
                        }
                    }
                }
            }
        }
    }

    .content_tow {
        border-radius: px2rem(25);
        margin-top: px2rem(20);
        background-color: #ffffff;

        .fengjiexiao {
            width: 100%;
            border: px2rem(1) dashed #DDDDDD;
            margin-top: px2rem(12) !important;
            margin-bottom: px2rem(12) !important;
        }

        .tow_title {
            display: flex;
            align-items: center;
            flex-direction: row;
            padding: px2rem(20);
            background: linear-gradient(90deg, #F9E6CA 0.88%, rgba(255, 251, 246, 0.00) 99.94%);
            border-top-right-radius: px2rem(25);
            border-top-left-radius: px2rem(25);

            .title_chu {
                width: 4px;
                height: 16px;
                margin-right: px2rem(10);

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .title_top {
                display: flex;
                flex: 1;
                justify-content: space-between;

                div {
                    color: #333;
                    font-family: Alibaba PuHuiTi;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 500;

                    /* 100% */

                }

                .top_red {
                    color: #E30F0F;
                    font-family: Alibaba PuHuiTi;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    /* 100% */
                }
            }

            div {
                color: #333;
                font-family: Alibaba PuHuiTi;
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                /* 100% */
            }
        }

        .tow_content {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            width: 100%;
            padding-top: px2rem(16);
            padding-bottom: px2rem(16);
            position: relative;

            .tow_content_tent {
                display: flex;
                width: 40%;
                // height: px2rem(120);
                flex-direction: column;
                justify-content: center;
                background-color: #f8f8f8;
                border-radius: 5px;
                padding: 8px;
                margin: px2rem(10);

                .tow_content_tent_top {
                    display: flex;
                    align-items: center;
                    flex-wrap: nowrap;
                    color: #666;
                    font-family: Alibaba PuHuiTi;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;

                    .doubt {
                        padding: 8px;
                        border-radius: 2px;
                        background: rgba(0, 0, 0, 0.70);
                        position: absolute;
                        margin-top: 80px;

                        div {
                            color: #FFF;
                            font-family: Alibaba PuHuiTi 3.0;
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 400;
                            display: inline-block;
                        }
                    }

                    .img {
                        width: 16px;
                        height: 16px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .img_text {
                        margin-left: px2rem(10);
                    }
                }

                .block {
                    margin-top: 12px;
                    color: #333;
                    font-family: Alibaba PuHuiTi;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                }

                .tow_content_tent_button {
                    color: #E30F0F;
                    text-align: left;
                    font-family: Alibaba PuHuiTi;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    margin-bottom: 8px;
                }

                .yess {
                    color: #05AC03;
                }
            }

        }
    }

    .content_throw {
        border-radius: px2rem(25);
        margin-top: px2rem(20);
        background-color: #ffffff;

        .tow_title {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            flex-direction: row;
            padding: px2rem(20);
            background: linear-gradient(90deg, #F9E6CA 0.88%, rgba(255, 251, 246, 0.00) 99.94%);
            border-top-right-radius: px2rem(25);
            border-top-left-radius: px2rem(25);

            .title_chu {
                width: 4px;
                height: 16px;
                margin-right: px2rem(10);

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .title_top {
                display: flex;
                flex: 1;
                justify-content: space-between;

                div {
                    color: #333;
                    font-family: Alibaba PuHuiTi;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 500;

                    /* 100% */

                }

                .top_red {
                    color: #E30F0F;
                    font-family: Alibaba PuHuiTi;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    /* 100% */
                }
            }

        }

        .throw_content {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            align-items: center;
            padding-left: px2rem(20);
            padding-right: px2rem(20);
            margin-bottom: px2rem(20);

            .content_tow {
                display: flex;
                flex-direction: column;
                // justify-content: center;
                // align-items: center;
                width: 40%;
                height: 50px;

                .tow_top {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;

                    .tow_img {
                        display: flex;
                        color: #666666;
                        font-size: px2rem(26);

                        .img {
                            width: 18px;
                            height: 18px;

                            img {
                                width: 100%;
                                height: 100%;
                                border-radius: 2px;
                                background: #FFC300;
                            }
                        }

                        .tow_img_text {
                            margin-left: px2rem(10);
                            color: #666;
                            font-family: Alibaba PuHuiTi 3.0;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 400;
                        }

                    }

                    .tow_right {
                        width: 33px;
                        height: 16px;
                        color: #666;
                        text-align: center;
                        font-family: Alibaba PuHuiTi;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        border-radius: 8px;
                        background: #F5F5F5;
                    }
                }


                .tow_yuan {
                    color: #333;
                    font-family: Alibaba PuHuiTi;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 500;
                    margin-top: px2rem(10);

                }

                .tow_button {
                    display: flex;
                    margin-top: px2rem(20);

                    .button_text {
                        font-size: px2rem(20);
                        color: #999999;
                        margin-right: px2rem(15);
                    }
                }
            }
        }

    }


    .content_foue {
        border-radius: px2rem(25);
        margin-top: px2rem(20);
        background-color: #ffffff;

        .tow_title {
            display: flex;
            align-items: center;
            flex-direction: row;
            padding: px2rem(20);
            background: linear-gradient(90deg, #F9E6CA 0.88%, rgba(255, 251, 246, 0.00) 99.94%);
            border-top-right-radius: px2rem(25);
            border-top-left-radius: px2rem(25);

            .title_chu {
                width: 4px;
                height: 16px;
                margin-right: px2rem(10);

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            div {
                color: #333;
                font-family: Alibaba PuHuiTi;
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                /* 100% */
            }
        }
    }

    .foue_content {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: px2rem(150);

        .content {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
        }

        .conten_one {
            width: 45%;
            margin-right: px2rem(10);
            text-align: center;
            color: #666;
            text-align: center;
            font-family: Alibaba PuHuiTi;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;

            .one_text {
                margin-top: px2rem(12);
                color: #333;
                text-align: center;
                font-family: Alibaba PuHuiTi 3.0;
                font-size: 18px;
                font-style: normal;
                font-weight: 500;

            }
        }

        .content_title {
            border: px2rem(1) dashed #DDD;
            height: px2rem(24);
            margin-left: px2rem(30);
            margin-right: px2rem(30);
        }
    }
}
</style>
<style scoped>
/* /deep/.el-tooltip {
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;
    -webkit-tap-highlight-color: transparent !important;
} */
/* /deep/ .el-tooltip div:focus img:focus{
    -webkit-ta--
} */
/* /deep/.el-tooltip div:focus img:focus {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    outline: 0 !important;
}

.img {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    outline: 0 !important;
} */
/deep/.el-tooltip div:focus img:focus {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    outline: 0 !important;
}

.img img:focus {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    outline: 0 !important;
    user-select: none;
    z-index: -1;
    background: transparent !important;
}
</style>